import useCourseDetail from '../useCourseDetail';
import useCourseEnrollment from '../useCourseEnrollment';

import { RegularCourseEnrollmentStatus } from '@redux/course/type/courseDetailType';

const useCourseRegularBanner = () => {
  const { name, price, courseDetailData, bannerPrimaryColor, bannerSecondaryColor } = useCourseDetail();
  const { courseEnrollmentStatus } = useCourseEnrollment();

  const isEnrolled = RegularCourseEnrollmentStatus.ENROLLED === courseEnrollmentStatus;

  return {
    isEnrolled,
    courseEnrollmentStatus,
    courseDetailData,
    name,
    price,
    bannerPrimaryColor,
    bannerSecondaryColor,
  };
};

export default useCourseRegularBanner;
